import React from 'react';
import CleanUpTable from './CleanUpTable';
import ColumnViewRowDetails from './ColumnViewRowDetails';
import { getVisibleColumns } from './TableSettings';

export { tempFilteredRows, columnType } from './CleanUpTable';
export { searchDataOriginalCusip } from './SearchHelper';

export default function Table({
  columns,
  renderRowDetailsAddOnButtons,
  ...props
}) {
  const filtered = props.noRowDetails
    ? columns
    : [
        ColumnViewRowDetails(() => {
          return { columns, title: props.title, id: props.id };
        }, renderRowDetailsAddOnButtons),
        ...columns,
      ];

  const origVisibleColumns = getVisibleColumns(filtered);
  const origColumnOrder = filtered.map((col, index) => index);

  // remove Select All in columns
  return (
    <CleanUpTable
      // columns={columns}
      columns={filtered}
      origVisibleColumns={origVisibleColumns}
      origColumnOrder={origColumnOrder}
      {...props}
    />
  );
}
